import React from "react";
import Grid from "@material-ui/core/Grid";
import { Page, Icon, Card, TextStyle } from "@shopify/polaris";
import {
  ListMajor,
  CustomersMajor,
  CategoriesMajor,
  CalendarMajor,
} from "@shopify/polaris-icons";
import history from "../../Assets/Lib/history";

const GridView = () => {
  return (
    <Page>
      <Card>
        <div style={{ padding: 20 }}>
          <Grid container spacing={3}>
            {/* <Grid item xs={4}>
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="gridItem"
                onMouseDown={(e) => history.push("/admin/events/labels")}
              >
                <div className="iconDiv">
                  <Icon
                    source={ListMajor}
                    style={{ margin: "0 5px" }}
                    color="subdued"
                  ></Icon>
                </div>
                <div style={{ flexDirection: "column", marginLeft: "10" }}>
                  <div className="titleDev">
                    <TextStyle variation="strong">Labels</TextStyle>
                  </div>
                  <div className="description">
                    <TextStyle></TextStyle>
                  </div>
                </div>
              </div>
            </Grid> */}
            <Grid item xs={4}>
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="gridItem"
                onMouseDown={(e) => history.push("/admin/events/categories")}
              >
                <div className="iconDiv">
                  <Icon
                    source={CategoriesMajor}
                    style={{ margin: "0 5px" }}
                    color="subdued"
                  ></Icon>
                </div>
                <div style={{ flexDirection: "column", marginLeft: "10" }}>
                  <div className="titleDev">
                    <TextStyle variation="strong">Categories</TextStyle>
                  </div>
                  <div className="description">
                    <TextStyle></TextStyle>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="gridItem"
                onMouseDown={(e) => history.push("/admin/events/speakers")}
              >
                <div className="iconDiv">
                  <Icon
                    source={CustomersMajor}
                    style={{ margin: "0 5px" }}
                    color="subdued"
                  ></Icon>
                </div>
                <div style={{ flexDirection: "column", marginLeft: "10" }}>
                  <div className="titleDev">
                    <TextStyle variation="strong">Speakers</TextStyle>
                  </div>
                  <div className="description">
                    <TextStyle></TextStyle>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                className="gridItem"
                onMouseDown={(e) => history.push("/admin/events/items")}
              >
                <div className="iconDiv">
                  <Icon
                    source={CalendarMajor}
                    style={{ margin: "0 5px" }}
                    color="subdued"
                  ></Icon>
                </div>
                <div style={{ flexDirection: "column", marginLeft: "10" }}>
                  <div className="titleDev">
                    <TextStyle variation="strong">Events</TextStyle>
                  </div>
                  <div className="description">
                    <TextStyle></TextStyle>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Card>
    </Page>
  );
};
export default GridView;
